module.exports = __webpack_public_path__ + "img/inactivecommu.b8605d26.svg";